import TileLayer from "ol/layer/Tile.js"
import TileWMS from 'ol/source/TileWMS.js';

import {urlGeoserver} from "./globals";

const climatWmsLayer0 = new TileLayer({
    source: new TileWMS({
        url: urlGeoserver+'ref_geo/wms', // URL du service WMS
        params: {
            'LAYERS': 'dc_agg_2020_pluviom',
            'TILED': true
        },
        serverType: 'geoserver',// Type de serveur WMS (ex: geoserver)
        crossOrigin: 'anonymous'// Permet les requêtes cross-origin (CORS)
    }),
    opacity:0.8,
    visible:false,
    title:"Climat"
});

export const climatWmsLayer=climatWmsLayer0;

export const paramClimatRepresentation = [
    {
        "nom":"Etat",
        "valeurs" : [
            {"id":"_pluviom","nom":"Pluviométrie (mm/an)"},
            {"id":"_ray_tot","nom":"Rayonnement annuel (W/m²/an)"},
            {"id":"_rh_ete","nom":"Humidité relative estivale (%)"},
            {"id":"_t_moy","nom":"Température moyenne (°C)"},
        ]
    },
    {
        "nom":"Potentiel",
        "valeurs" : [
            {"id":"_dju","nom":"Degrés jours unifiés (°C )"},
            {"id":"_nj_tmax_28","nom":"Nb jours t max > 28°C (jours)"},
            {"id":"_nj_vent_depasse_3_6","nom":"Nb jours vent > 3,6m/s (jours)"},
            {"id":"_vent_diurne_ete","nom":"Ventilation diurne (%)"},
            {"id":"_vent_nocturne_ete","nom":"Ventilation nocturne (%)"},
        ]
    },
];

export const paramClimatAnnee = [
    {"id":"dc_agg_1950","nom":"1950"},
    {"id":"dc_agg_2020","nom":"2020"},
    {"id":"dc_agg_2050","nom":"2050"},
    {"id":"dc_agg_2100","nom":"2100"},
]